/**
 * Ermöglicht die Anzeige eines Lexikoneintrags.
 * @class directive_v3sLexikon
 * @memberOf v3sWbtPlayerApp:tools:search
 */
angular.module('v3sWbtPlayerApp').directive('v3sLexikon', ["$compile", "v3sContentMediaPath", "v3sServiceFinder", function ($compile, v3sContentMediaPath, v3sServiceFinder) {
    return {
        restrict: 'E',
        scope : { },
        transclude: false,
        templateUrl: "app/js/tools/search/lexikonContent.tpl.html",
        link: function (scope, element, attrs) {
            var v3sSelectionService = v3sServiceFinder.get("v3sSelectionService");
            scope.entry = scope.$parent.entry;

            if (scope.entry.graphic) {
                scope.entry.graphic.src = v3sContentMediaPath + "/include/lexikon/" + scope.entry.graphic.file;
            }

            var contentElement = angular.element(scope.entry.content);
            $compile(contentElement)(scope);

            element.find("v3s-content-target").replaceWith(contentElement);

            element[0].id = scope.entry.id;
            if (v3sSelectionService) v3sSelectionService.setLexikonElement(element);
        }
    }
}]);
